import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { UrlConstants } from './shared/utils/url-constants';
import { PageDataGuard } from './core/guards/page-data.guard';
import { DocumentationComponent } from './modules/documentation/documentation.component';

const routes: Routes = [
  {
    path: UrlConstants.HOME_PAGE,
    loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule),
    canActivate: [PageDataGuard],
    data: { showHeader: false, showSidenav: false, showFooter: false }
  },
  {
    path: UrlConstants.DASHBOARD,
    loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard, PageDataGuard]
  },

  {
    path: UrlConstants.UID_CHECK,
    loadChildren: () => import('./modules/uid-check/uid-check.module').then(m => m.UidCheckModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.ECONOMIC_OPERATORS,
    loadChildren: () => import('./modules/economic-operators/economic-operators.module').then(m => m.EconomicOperatorsModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.FACILITIES,
    loadChildren: () => import('./modules/facilities/facilities.module').then(m => m.FacilitiesModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.MACHINES,
    loadChildren: () => import('./modules/machines/machines.module').then(m => m.MachinesModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.PRODUCTION,
    loadChildren: () => import('./modules/production/production.module').then(m => m.ProductionModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.PRODUCTS,
    loadChildren: () => import('./modules/products/products.module').then(m => m.ProductsModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.STAMPS,
    loadChildren: () => import('./modules/stamps/stamps.module').then(m => m.StampsModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.DOMAIN,
    loadChildren: () => import('./modules/product-domain/product-domain.module').then(m => m.ProductDomainModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.TYPE,
    loadChildren: () => import('./modules/product-type/product-type.module').then(m => m.ProductTypeModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.ORDERS,
    loadChildren: () => import('./modules/orders/orders.module').then(m => m.OrdersModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.TAX_LEVELS,
    loadChildren: () => import('./modules/tax-level/tax-level.module').then(m => m.TaxLevelModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.EXCISE_WAREHOUSES,
    loadChildren: () => import('./modules/excise-warehouses/excise-warehouses.module').then(m => m.ExciseWarehousesModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.MONITORING,
    loadChildren: () => import('./modules/monitoring/monitoring.module').then(m => m.MonitoringModule)
  },
  {
    path: UrlConstants.TRACK_AND_TRACE,
    loadChildren: () => import('./modules/track-and-trace/track-and-trace.module').then(m => m.TrackAndTraceModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.REPORTING,
    loadChildren: () => import('./modules/reporting/reporting.module').then(m => m.ReportingModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.ADVANCED_REPORTING,
    loadChildren: () => import('./modules/reporting-advanced/reporting-advanced.module').then(m => m.ReportingAdvancedModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.CHANGE_LOGS,
    loadChildren: () => import('./modules/change-logs/change-logs.module').then(m => m.ChangeLogsModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.USERS,
    loadChildren: () => import('./modules/users/users.module').then(m => m.UsersModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.SETTINGS,
    loadChildren: () => import('./modules/settings/settings.module').then(m => m.SettingsModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.ACCOUNT,
    loadChildren: () => import('./modules/account/account.module').then(m => m.AccountModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.MESSAGES,
    loadChildren: () => import('./modules/messages/messages.module').then(m => m.MessagesModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  {
    path: UrlConstants.DOCUMENTATION,
    component: DocumentationComponent,
    canActivate: [AuthGuard, PageDataGuard],
    data: { showHeader: false, showSidenav: false, showFooter: false }
  },
  {
    path: UrlConstants.APPROVALS,
    loadChildren: () => import('./modules/approvals/approvals.module').then(m => m.ApprovalsModule),
    canActivate: [AuthGuard, PageDataGuard]
  },
  { path: '**', redirectTo: UrlConstants.DASHBOARD }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
